import { put } from 'redux-saga/effects';
import Cookies from '../services/cookies';
import { COOKIE_NAME_URBN_DEVICE_TYPE } from '../constants';
import { updatedSize } from '../actions/deviceActions';
import { determineSize, determineSizeTypes } from '../utils/deviceUtils';

/**
 * Determines the user's true device width and compares if it matches the URBN_DEVICE_TYPE cookie,
 * if not updates the cookie
 */
export function* updateDeviceSizeSaga() {
    const cookieSize = Cookies.getCookieByName(COOKIE_NAME_URBN_DEVICE_TYPE);
    const clientSizeTypes = determineSizeTypes(cookieSize);
    const clientSize = determineSize(clientSizeTypes, cookieSize);

    if (cookieSize !== clientSize) {
        Cookies.setCookie(COOKIE_NAME_URBN_DEVICE_TYPE, clientSize);
        yield put(updatedSize(clientSizeTypes, true));
    }
}
